"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAllPermi = checkAllPermi;
exports.checkPermi = checkPermi;
exports.checkRole = checkRole;
var _store = _interopRequireDefault(require("@/store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
function checkPermi(value) {
  if (value && value instanceof Array && value.length > 0) {
    var permissions = _store.default.getters && _store.default.getters.permissions;
    var permissionDatas = value;
    var all_permission = '*:*:*';
    var hasPermission = permissions.some(function (permission) {
      return all_permission === permission || permissionDatas.includes(permission);
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    console.error("need roles! Like checkPermi=\"['system:user:add','system:user:edit']\"");
    return false;
  }
}

/**
 * 检查是否拥有所有指定权限（AND关系）
 * @param {Array} permissions 需要检查的权限数组
 * @returns {Boolean}
 */
function checkAllPermi(permissions) {
  if (permissions && Array.isArray(permissions) && permissions.length > 0) {
    var userPermissions = _store.default.getters && _store.default.getters.permissions;
    var all_permission = '*:*:*';

    // 如果有超级权限，直接返回true
    if (userPermissions.includes(all_permission)) {
      return true;
    }

    // 检查是否拥有所有指定权限
    return permissions.every(function (permission) {
      return userPermissions.includes(permission);
    });
  } else {
    console.error("need permissions! Like checkAllPermi(['platform:competitor:edit', 'platform:competitor:view'])");
    return false;
  }
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
function checkRole(value) {
  if (value && value instanceof Array && value.length > 0) {
    var roles = _store.default.getters && _store.default.getters.roles;
    var permissionRoles = value;
    var super_admin = 'admin';
    var hasRole = roles.some(function (role) {
      return super_admin === role || permissionRoles.includes(role);
    });
    if (!hasRole) {
      return false;
    }
    return true;
  } else {
    console.error("need roles! Like checkRole=\"['admin','editor']\"");
    return false;
  }
}